import { css } from '@/styled-system/css';

export const cityPageStyles: string = css({
  margin: '16px',
  md: {
    margin: '30px',
  },
  lg: {
    margin: '44px',
  },
  xl: {
    margin: '92px',
  },
});

export const cityPageTabsStyles: string = css({
  maxHeight: '80px',
  overflowY: 'hidden',
  overflowX: 'auto',
  whiteSpace: 'nowrap',
});

export const cityPageTabStyles: string = css({
  whiteSpace: 'normal',
  minWidth: '100px',
});
